import React from "react"
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"

import * as S from "./styles"

const RecommendedPosts = ({ next, previous }) => {
  if (!next && !previous) return null

  return (
    <S.RecommendedWrapper>
      {previous && (
        <S.RecommendedLink to={previous.fields.slug} className="previous">
          <FaArrowLeft size={20} />
          {previous.frontmatter.title}
        </S.RecommendedLink>
      )}
      {next && (
        <S.RecommendedLink to={next.fields.slug} className="next">
          {next.frontmatter.title}
          <FaArrowRight size={20} />
        </S.RecommendedLink>
      )}
    </S.RecommendedWrapper>
  )
}

export default RecommendedPosts
